import { Theme } from '@mui/material';
import { APP_HEADER_HEIGHT_MD } from '../../../../layouts/authneticated-layout/constants';

/**
 * Desktop (`direction="horizontal"`) width of the Properties order map.
 *
 * Keeps the usual 50% column share but never lets the square outgrow the viewport height left below the shared
 * order shell. PropertiesMap derives the height from this width (`aspect-ratio: 1 / 1`), so capping the width
 * caps both sides and the map shrinks instead of being clipped. Not used on compact widths (full-width square).
 *
 * Height reserved above and around the map:
 *   81px  app bar spacer
 *   48px  order tabs (`spacing(6)`, order-overview-tabs)
 *   64px  information bar (`spacing(8)`: 2 x `spacing(1)` padding + title/value block of a single-property order;
 *         each additional property row makes the bar taller than this reserve)
 *   24px  PropertiesMap root top padding (`spacing(3)`)
 *   24px  breathing room below the map, matching that padding (`spacing(3)`)
 */
export const getDesktopMapWidth = (theme: Theme) => {
  const reservedHeight = APP_HEADER_HEIGHT_MD + parseFloat(theme.spacing(6)) + parseFloat(theme.spacing(8)) + parseFloat(theme.spacing(3)) + parseFloat(theme.spacing(3));

  return `min(50%, calc(100vh - ${reservedHeight}px))`;
};
